function checkDeepLink(vdir: string, pathnameParts: string[]): boolean {
    return (
        pathnameParts[1] == vdir &&
        (pathnameParts[2]?.indexOf('deeplink') == 0 || pathnameParts[3]?.indexOf('deeplink') == 0)
    );
}

// This function is temporary, this is just to scope the new densities to mail while other teams are working on their respective densities.
// this code is a simplified version of owa-mail-bootstrap's determinemodule. Due to circular dependencies and the life span of this function, we are not using it.
export function isMailModule(): boolean {
    const pathname = window.location.pathname;

    const pathnameParts = pathname.split('/');
    return checkDeepLink('mail', pathnameParts) || pathname.indexOf('/mail') == 0 || !pathname;
}
